/**
 * Configuration object for the feature switch.
 * This object can be used with the dataModule to request feature switch data.
 *
 * Example usage:
 * fetchFeatureSwitchesDataModule.dataRequest(PARTNER_ONBOARDING_METAL_CARD_FEATURE_SWITCH);
 *
 * @property {string} featureName - The name of the feature used in the request query.
 * @property {string} storeName - The name of the redux store associated with the feature switch.
 */

export const PHO_MANUAL_PAYMENT_CS_NUMBER_FEATURE_SWITCH = {
    featureName: 'PHO_MANUAL_PAYMENT_CS_NUMBER',
    storeName: 'phoManualPaymentCustomerServiceNumber',
};

export const REVIEW_PROMPTING_UX_FEATURE_SWITCH = {
    featureName: 'REVIEW_PROMPTING_UX',
    storeName: 'reviewPromptingUX',
};
